import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Spinner } from '@/shared/ui';

import { EncounterAbstract } from '@/entities/transcriptor';

import { dentalConsultationMessages } from '../../config';
import { ConsultationContent } from '../ConsultationContent/ConsultationContent';

import styles from './AbstractBlock.module.scss';

type AbstractBlockProps = {
  className?: string;
  abstract?: EncounterAbstract | null;
};

export const AbstractBlock: FC<AbstractBlockProps> = ({
  className,
  abstract,
}) => {
  const content = abstract?.content?.trim();
  const isProcessing =
    abstract?.status === 'pending' || abstract?.status === 'generating';

  // Nothing to show for old consultations without an abstract, or for a
  // failed/skipped abstract that produced no text.
  if (!abstract || (!content && !isProcessing)) {
    return null;
  }

  return (
    <div
      className={cn(styles.container, className)}
      data-component="consultation-abstract-block"
    >
      <div className={styles.row}>
        <div className={cn('h6', styles.label)}>
          <FormattedMessage
            {...dentalConsultationMessages.executiveSummaryTitle}
          />
        </div>

        <div className={styles.value}>
          {isProcessing ? (
            <div className={cn(styles.processingState, 'p2')}>
              <Spinner size={20} />
              <FormattedMessage
                {...dentalConsultationMessages.executiveSummaryProcessing}
              />
            </div>
          ) : (
            content && <ConsultationContent text={content} />
          )}
        </div>
      </div>
    </div>
  );
};
